// SerieDocFT
const props = {
  FT: 'SerieDocFT',
  DDT: 'SerieDocDDT',
  FTPa: 'SerieDocFTPa',
  NC: 'SerieDocNC',
  NCPa: 'SerieDocNCPa',
}

export default {
  namespaced: true,

  getters: {
    cashableOffices: (_, __, rootState) => rootState.apis.offices.filter(o => Boolean(o.CassaDataSaldoIniziale)),
    getSeries: (_, __, rootState) => prop => rootState.apis.offices
      .map(({ [props[prop]]: serie }) => serie)
      .filter(Boolean),
    getSerie: (_, __, ___, rootGetters) => (id, prop) =>
      rootGetters['apis/getObj']({ id, key: 'offices' })[props[prop]],
  },
}
